import { useFormsContext } from 'pages/forms/context';
import { useCallback, useMemo } from 'react';
import { CloudUpload } from '@material-ui/icons';
import React from 'react';
import { useStyles } from './styles';
import { useCsv } from 'hooks/useCsv';

interface IProps {
  rowIndex: number;
}

export const ExportButton = ({ rowIndex }: IProps) => {
  const { data, loadGetSuppliersAnswers } = useFormsContext();
  const { generateCsv } = useCsv();
  const styles = useStyles();

  const formData = useMemo(() => {
    return data[rowIndex];
  }, [data, rowIndex]);

  const handleClick = useCallback(async () => {
    await loadGetSuppliersAnswers(formData.idForm).then((a) => {
      generateCsv({ data: a, filename: formData.nmForm, delimitator: ';' });
    });
  }, [loadGetSuppliersAnswers, formData]);

  return (
    <div className={styles.button} onClick={handleClick}>
      <CloudUpload />
    </div>
  );
};
